import { Button } from "@mui/material";
import { exportToExcel } from "../utils/exportToExcel";

export default function DownloadExcel({tableRef, filename, sx}){

    return(
        <Button variant="contained" sx={{ ...sx, background: "#217346"}} onClick={() => {exportToExcel(tableRef, filename)}}>Export to Excel</Button>
    )
}